var _path, _circle, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStoppedDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.72 8.13333V5.13421L24.7191 9.13333H21.72C21.1677 9.13333 20.72 8.68562 20.72 8.13333ZM28 10.1333C28 10.1109 27.9993 10.0886 27.9978 10.0666C28.0162 9.78893 27.9193 9.50509 27.7071 9.29289L20.7071 2.29289C20.4762 2.06199 20.1605 1.96761 19.8602 2.00976C19.8144 2.00333 19.7676 2 19.72 2H5.00004C4.44776 2 4.00004 2.44772 4.00004 3V16V25L4 29C3.99999 29.5523 4.44771 30 5 30H9.00003H17V28H9.00003H6.00001L6.00004 25V16V4H18.72V8.13333C18.72 9.79019 20.0631 11.1333 21.72 11.1333H26V18H28V10.1333Z",
    fill: "#9FA6AD"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 23.5,
    r: 7.5,
    stroke: "#9FA6AD",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 18L28 29",
    stroke: "#9FA6AD",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoppedDark);
export default __webpack_public_path__ + "static/media/stoppedDark.2eb863a653e1d271f279b16f815d4e3c.svg";
export { ForwardRef as ReactComponent };